/** Cryptographically secure random helpers (Web Crypto API). */

function getCrypto(): Crypto {
  if (typeof globalThis.crypto !== 'undefined') return globalThis.crypto
  throw new Error('Web Crypto API is not available')
}

/** UUID v4 for client IDs, idempotency keys, toast keys, etc. */
export function randomUUID(): string {
  return getCrypto().randomUUID()
}

/** Client-scoped unique string with optional prefix, e.g. `user-<uuid>`. */
export function clientUniqueId(prefix = 'id'): string {
  return `${prefix}-${randomUUID()}`
}

/** Uniform float in [0, 1). */
export function randomUnitFloat(): number {
  const buf = new Uint32Array(1)
  getCrypto().getRandomValues(buf)
  return buf[0]! / 0x1_0000_0000
}

/** Uniform integer in [0, max). */
export function randomInt(max: number): number {
  if (max <= 0) return 0
  const buf = new Uint32Array(1)
  getCrypto().getRandomValues(buf)
  return buf[0]! % max
}
